export default {
  LIST_FETCHED: 'USER_SHOPPING_CART_FETCHED',
  LIST_LOAD: 'USER_SHOPPING_CART_LOAD',
  ITEM_DETAIL: 'USER_SHOPPING_CART_DETAIL',
  BUTTON_LOAD: 'USER_SHOPPING_CART_BUTTON_LOAD',
};
